import React from 'react'
import { useTranslation } from 'react-i18next'

import { ReactComponent as WarningIcon } from '../../../../assets/icons/warning-icon.svg'

import useDrawerFormClasses from '../../../../styles/common/drawerForms'

const FacebookBusinessManagerMissingWarning = () => {
  const { t } = useTranslation()

  const drawerFormClasses = useDrawerFormClasses()

  return (
    <section className={drawerFormClasses.section}>
      <div className={drawerFormClasses.sectionInfoIconWrapper}>
        <WarningIcon />
      </div>
      <p>{t('Sorry, you should have Facebook business manager id associated with this account to use this form.')}</p>
    </section>
  )
}

export default FacebookBusinessManagerMissingWarning
